// 域名映射环境变量
const envConfig = {
  'mtp-uat.wanyol.com': 'uat',
  'mtp-test.myoas.com': 'test',
  'mtp.myoas.com': 'release',
  'mtp-dev.myoas.com': 'dev',
  'mtp-gray.oppoit.com': 'release',
  'mtp.oppowork.com': 'release'
}
/**
 * 工具类，鼓励大家把公共方法定义在此处
 */
const Util = {
  getEnv() {
    return envConfig[location.host] || 'local'
  },
  // 封装qing.call方法
  callNew(name, data, errorCallback) {
    if (typeof name !== 'string') return
    let nameList = [].concat(name)
    qing.call('mtp.checkJsApi', {
      jsApiList: nameList,
      success: function (result) {
        if (result && result.data && result.data[name]) {
          qing.call(name, data)
        } else {
          console.info(`[fail] mtp.checkJsApi ${name} -> `, result)
          errorCallback && errorCallback(result)
        }
      },
      error: function (result) {
        console.info(`[error] mtp.checkJsApi ${name} -> `, result)
        errorCallback && errorCallback(result)
      }
    })
  },
  call(name, data, errorCallback) {
    if (typeof name !== 'string') return
    let nameList = [].concat(name)
    qing.call('checkJsApi', {
      jsApiList: nameList,
      success: function (result) {
        if (result && result.data && result.data[name]) {
          qing.call(name, data)
        } else {
          console.info(`[fail] checkJsApi ${name} -> `, result)
          errorCallback && errorCallback(result)
        }
      },
      error: function (result) {
        console.info(`[error] checkJsApi ${name} -> `, result)
        errorCallback && errorCallback(result)
      }
    })
  },
  isMobile: (function () {
    let ua = navigator.userAgent || ''
    let reg =
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    let flag = reg.test(ua)
    return flag
  })()
}

export default Util
